<template>
	<span
		:class="['Tag', variant]"
		:aria-label="label"
	>
		<i
			v-if="variant === 'highlighted'"
			class="Check lnr-check"
		></i>
		{{ label }}
		<span
			v-if="counter"
			class="Counter"
			:aria-label="`+${counter} more`"
		>
			+{{ counter }}
		</span>
	</span>
</template>
<script setup lang="ts">
const props = defineProps({
	label: {
		type: String,
		required: true,
	},
	counter: {
		type: Number,
		required: false,
	},
	variant: {
		type: String,
		required: false,
		default: 'default',
	},
});
</script>

<style scoped lang="scss">
	.Tag {
		display: flex;
		height: 1.5rem;
		align-items: center;
		border-radius: 0.25rem;
		user-select: none;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;

		@include TextStyle(UiSmallSemibold);
		@include PaddingAreas(0, 0.25);

		&.default {
			background-color: $Grey-100;
			color: $Grey-900;
		}

		&.highlighted {
			background-color: $Green-100;
			color: $Grey-900;
		}

		.Counter {
			color: $Grey-700;
			@include MarginAreas(0, 0, 0, 0.25);
		}

		.Check {
			font-size: 0.75rem;
			color: $Green-900;
			@include MarginAreas(0, 0.25);
		}
	}
</style>
